<template>
  <div class="space-y-6">
    <!-- Sounds -->
    <div class="rounded-md border border-stone-200 dark:border-stone-700 bg-white/60 dark:bg-stone-800/40 p-3">
      <h3 class="text-sm font-semibold text-stone-700 dark:text-stone-300 mb-2">
        {{ t('optionsdialog.Sounds') }}
      </h3>
      <afterSpinSoundPicker
        :afterSpinSound="wheelConfig.afterSpinSound"
        :afterSpinSoundVolume="wheelConfig.afterSpinSoundVolume"
        :firstTextOnWheel="firstTextOnWheel"
        @set-after-spin-sound="$emit('set-after-spin-sound', $event)"
        @set-after-spin-sound-volume="$emit('set-after-spin-sound-volume', $event)"
      />
      </div>

    <!-- Effects -->
    <div class="rounded-md border border-stone-200 dark:border-stone-700 bg-white/60 dark:bg-stone-800/40 p-3">
      <h3 class="text-sm font-semibold text-stone-700 dark:text-stone-300 mb-3">
        {{ t('optionsdialog.Effects') }}
      </h3>
      <div class="space-y-2">
        <label class="flex items-start gap-3">
          <input id="animateWinner" type="checkbox" v-model="wheelConfig.animateWinner"
            class="form-checkbox h-4 w-4 mt-0.5 text-primary-500 rounded focus:ring-primary-500 border-stone-300 dark:border-stone-600" />
          <span class="text-stone-700 dark:text-stone-300">
            {{ t('optionsdialog.Animate winning entry') }}
          </span>
        </label>

        <label class="flex items-start gap-3">
          <input id="launchConfetti" type="checkbox" v-model="wheelConfig.launchConfetti"
            class="form-checkbox h-4 w-4 mt-0.5 text-primary-500 rounded focus:ring-primary-500 border-stone-300 dark:border-stone-600" />
          <span class="text-stone-700 dark:text-stone-300">
            {{ t('optionsdialog.Launch confetti') }}
          </span>
        </label>

        <label class="flex items-start gap-3">
          <input id="autoRemoveWinner" type="checkbox" v-model="wheelConfig.autoRemoveWinner"
            class="form-checkbox h-4 w-4 mt-0.5 text-primary-500 rounded focus:ring-primary-500 border-stone-300 dark:border-stone-600" />
          <span class="text-stone-700 dark:text-stone-300">
            {{ t('optionsdialog.Auto-remove winner after 5 seconds') }}
          </span>
        </label>
      </div>
    </div>

    <!-- Winner dialog -->
    <div class="rounded-md border border-stone-200 dark:border-stone-700 bg-white/60 dark:bg-stone-800/40 p-3">
      <div class="flex items-start gap-3">
        <input id="displayWinnerDialog" type="checkbox" v-model="wheelConfig.displayWinnerDialog"
          class="form-checkbox h-4 w-4 mt-0.5 text-primary-500 rounded focus:ring-primary-500 border-stone-300 dark:border-stone-600" />
        <label for="displayWinnerDialog" class="text-stone-700 dark:text-stone-300">
          {{ t('optionsdialog.Display popup with message:') }}
        </label>
      </div>

      <div class="mt-3">
        <input type="text" v-model="wheelConfig.winnerMessage" :disabled="!wheelConfig.displayWinnerDialog"
          maxlength="100" aria-disabled="!wheelConfig.displayWinnerDialog"
          class="w-full px-3 py-2 border border-stone-300 dark:border-stone-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 disabled:opacity-50 dark:bg-stone-700 dark:text-stone-200" />
        <p class="mt-1 text-xs text-stone-500 dark:text-stone-400">
          {{ t('common.Max') || 'Max' }} 100
        </p>
      </div>

      <div class="mt-3">
        <label class="flex items-center">
          <input id="displayRemoveButton" type="checkbox" v-model="wheelConfig.displayRemoveButton"
            :disabled="!wheelConfig.displayWinnerDialog"
            class="form-checkbox h-4 w-4 text-primary-500 rounded focus:ring-primary-500 border-stone-300 dark:border-stone-600 disabled:opacity-50" />
          <span class="ml-2 text-stone-700 dark:text-stone-300"
            :class="{ 'opacity-50': !wheelConfig.displayWinnerDialog }">
            {{ t('optionsdialog.Display Remove button') }}
          </span>
        </label>

        <label v-if="wheelConfig.isAdvanced" class="flex items-center">
          <input id="displayHideButton" type="checkbox" v-model="wheelConfig.displayHideButton"
            :disabled="!wheelConfig.displayWinnerDialog"
            class="form-checkbox h-4 w-4 text-primary-500 rounded focus:ring-primary-500 border-stone-300 dark:border-stone-600 disabled:opacity-50" />
          <span class="ml-2 text-stone-700 dark:text-stone-300"
            :class="{ 'opacity-50': !wheelConfig.displayWinnerDialog }">
            {{ t('optionsdialog.Display Hide button') }}
          </span>
        </label>
      </div>

      <div class="mt-3">
        <label class="flex items-start gap-3">
          <input id="playClickWhenWinnerRemoved" type="checkbox" v-model="wheelConfig.playClickWhenWinnerRemoved"
            class="form-checkbox h-4 w-4 mt-0.5 text-primary-500 rounded focus:ring-primary-500 border-stone-300 dark:border-stone-600" />
          <span class="text-stone-700 dark:text-stone-300">
            {{ t('optionsdialog.Play click sound when the winner is removed') }}
          </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import afterSpinSoundPicker from '@/components/audio/afterSpinSoundPicker.vue';

defineProps({
  wheelConfig: { type: Object, required: true },
  firstTextOnWheel: { type: String, default: '' }
});

defineEmits(['set-after-spin-sound', 'set-after-spin-sound-volume']);

const { t } = useI18n();
</script>
